// extracted by mini-css-extract-plugin
export var badge = "styles-module--badge--0f192";
export var container = "styles-module--container--c669c";
export var content = "styles-module--content--727ed";
export var image = "styles-module--image--b60ed";
export var logo = "styles-module--logo--677aa";
export var section = "styles-module--section--47d53";
export var title = "styles-module--title--d0a10";